import { RequestMethodsEnum as s } from "@systemeio/util";
import v from "axios";
import { getRemoveDraftCommonFilePath as P, getRemoveDraftFilePath as u, getActivateCommonFilePath as a, getActivatePublicFilePath as C, getActivateFilePath as D, COMMON_DATA_FILES_VALIDATION_API_PATH as _, PUBLIC_DATA_FILES_VALIDATION_API_PATH as I, DATA_FILES_VALIDATION_API_PATH as A } from "../api/index.mjs";
import { useFetch as n } from "../../../utils/http-client.mjs";
const V = (t) => {
  const { fetcher: d } = n({
    method: s.post
  }), { fetcher: h } = n({
    method: s.post
  }), { fetcher: F } = n({
    method: s.delete
  });
  return {
    validateAndGetUploadOptions: async ({
      file: c,
      source: o,
      mimeType: m,
      cancelToken: r
    }) => await d(
      t != null && t.isCommon ? _ : t != null && t.isPublic ? I : A,
      {
        source: o,
        fileName: c.name,
        fileSize: c.size,
        mimeType: m,
        isCommon: (t == null ? void 0 : t.isCommon) ?? !1
      },
      {
        cancelToken: r
      }
    ),
    uploadToFileStore: async ({
      file: c,
      uploadOptions: o,
      progressHandler: m,
      cancelToken: r
    }) => {
      const e = new FormData();
      return e.append("key", o.key), e.append("acl", o.acl), e.append("X-Amz-Credential", o.credential), e.append("X-Amz-Algorithm", o.algorithm), e.append("X-Amz-Date", o.date), e.append("Policy", o.policy), e.append("X-Amz-Signature", o.signature), e.append("Content-Type", o.contentType), e.append("Cache-Control", o.cacheControl), e.append("file", c), await v.post(o.url, e, {
        onUploadProgress: m,
        cancelToken: r
      });
    },
    activate: async ({
      fileId: c,
      cancelToken: o
    }) => await h(
      t != null && t.isCommon ? a(c) : t != null && t.isPublic ? C(c) : D(c),
      {},
      {
        cancelToken: o,
        headers: {
          "Content-Type": "application/json"
        }
      }
    ),
    removeDraftFile: async (c) => await F(t != null && t.isCommon ? P(c) : u(c))
  };
};
export {
  V as useFileUploaderActions
};
